import { Colors } from "@brg/ui";
import styled from "styled-components";

export const StatsContainer = styled.div`
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    background: #212120;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StatsContent = styled.div`
    width: 100%;
    max-width: 1280px;
    background: #212120;
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

export const StatsText = styled.div`
    color: ${Colors.galBlack47};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter;
    font-size: 43px;
    font-style: normal;
    font-weight: 500;
    line-height: 51px; /* 118.605% */
    letter-spacing: -0.86px;
`;

export const StatsNumber = styled.div`
    color: ${Colors.gallWhite};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Korataki;
    font-size: 140px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 140px */
    letter-spacing: -2.8px;
`;

export const StatsSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 31px;
`;

export const Divider = styled.div`
    width: 408px;
    height: 2px;
    flex-shrink: 0;
    border: 1px solid ${Colors.galBlack73};
    margin: 0 auto;
`;

export const DateText = styled.div`
    color: ${Colors.galBlack47};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: -0.4px;
`;

export const NoConnectionText = styled.div`
    color: #FD6C52;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.4px;
`;

export default StatsContainer;import { Colors } from "@brg/ui";
import styled from "styled-components";

export const StatsContainer = styled.div`
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    background: #212120;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StatsContent = styled.div`
    width: 100%;
    max-width: 1280px;
    background: #212120;
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

export const StatsText = styled.div`
    color: ${Colors.galBlack47};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter;
    font-size: 43px;
    font-style: normal;
    font-weight: 500;
    line-height: 51px; /* 118.605% */
    letter-spacing: -0.86px;
`;

export const StatsNumber = styled.div`
    color: ${Colors.gallWhite};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Korataki;
    font-size: 140px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 140px */
    letter-spacing: -2.8px;
`;

export const StatsSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 31px;
`;

export const Divider = styled.div`
    width: 408px;
    height: 2px;
    flex-shrink: 0;
    border: 1px solid ${Colors.galBlack73};
    margin: 0 auto;
`;

export const DateText = styled.div`
    color: ${Colors.galBlack47};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: -0.4px;
`;

export const NoConnectionText = styled.div`
    color: #FD6C52;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.4px;
`;

export default StatsContainer;